<template>
    <div class="w100" style=" background: #01033c;">
        <article class="content-bg" style="padding-top: 40px;">
            <div class="logo-position">
                <img src="../../assets/images/ej/meetingLogo.png" alt="" srcset="" style="width: 200px">
                <p class="mt30">感谢有你</p>
                <p>共创辉煌</p>
                <div class="mt30"><span></span></div>
                <div><span></span></div>
                <div><span></span></div>
                <div><span></span></div>
            </div>
            <div class="logo-position textRight" style="right: 60px; left: auto;">
                <img src="../../assets/images/ej/meetingLogo.png" alt="" srcset="" style="width: 200px">
                <p class="mt30">感谢有你</p>
                <p>共创辉煌</p>
                <div class="mt30"><span></span></div>
                <div class=""><span></span></div>
                <div class=""><span></span></div>
                <div class=""><span></span></div>
            </div>
            <div class="wContent center">
                <div class="textCenter">
                    <img src="../../assets/images/ej/activity_boxing/2023.png" alt="" srcset="" style="width: 340px;"><br>
                    <img src="../../assets/images/ej/activity_boxing/name.png" alt="" srcset="" style="width: 770px;" class="mt30">
                    <p class="title-text mt40 fontWhite">2023 · 中国 · 博兴</p>
                    <!-- <p class="title-text-en mt10 fontWhite">WITHOUT BOUNDARIES</p> -->
                    <p class="time-text textCenter center mt40">时间： 2023年4月20日，地点： 山东省滨州市博兴县中悦国际大酒店</p>
                </div>
                <div class="center meeting-jj">
                    <p class="textCenter meeting-jj-title">会议简介</p>
                    <p>第一季度，国际“黑天鹅”事件频发，海外金融市场动荡，市场避险情绪升温，国内经济仍处于经济复苏阶段，钢材的需求强度面临较大的考验，黑色系步履蹒跚经历了先涨后跌行情。二季度的黑色系将经历怎么的逻辑演变? 市场是延续更加艰难的局面，还是还是冲出云雾迎接曙光?企业将如何做好应对措施? 本次论坛唐宋大数据将提前预警风险，为稳定市场、帮助企业获益尽微薄之力。<br/>
					   现场众多重磅嘉宾将发表洞见，为您拨开重重迷雾。共同探讨市场,抓住机遇，规避风险！</p>
                </div>
                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;程</span></p>
                    <div class="meeting-yc-content center mt30">
                        <h2>
                            <span>下午</span><br>
                            <span>4月20日</span>
                        </h2>
						<div class="line"></div>
                        <div>
                            <p class="time-line-content">
                                <span class="fontWhite font14">13:30-14:00</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">嘉宾签到</span>
                                <a class="shuline" style="height: 50px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">14:00-14:30</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">致辞</span>
                                <span class="right-text">
                                    河北唐宋大数据产业股份有限公司董事长
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;宋雷<br>
                                    山东大宗商品交易中心市场业务部总监
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;郭垣辰<br>
                                    德天（天津）国际贸易发展有限公司总经理助理&nbsp;&nbsp;&nbsp;&nbsp;魏智海<br>
                                </span>
                                <a class="shuline" style="height: 220px;"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">14:30-14:40</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《绿色环保是每一家钢企的社会责任》<br>
                                    <span class="right-intro">赤峰中唐特钢有限公司销售部副部长 王林南</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">14:40-15:10</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《山东板材市场分析》<br>
                                    <span class="right-intro">山东能源集团营销贸易有限公司期货总监</span>
									<span class="right-intro">&nbsp;大宗商品研究院负责人 娄童贤</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">15:10-15:30</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《二季度钢材价格与成本走势分析》<br>
                                    <span class="right-intro">东亚期货黑色产业研究负责人 郑威</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">15:30-15:35</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《天津源泰德润钢管制造集团有限公司品牌介绍》<br>
                                    <span class="right-intro">天津源泰德润钢管制造集团有限公司  营销部经理  李汉尊</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">15:35-15:55</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《预警讲市场》<br>
                                    <span class="right-intro">河北唐宋大数据产业股份有限公司分析师 王兰彩</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">15:55-16:30</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    《顺势有为，跨越周期》<br>
                                    <span class="right-intro">河北唐宋大数据产业股份有限公司董事长   宋雷</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
							<p class="time-line-content">
							    <span class="fontWhite font14">16:30-17:30</span>
							    <span class="point"></span>
							    <span class="fontWhite font14">
							        高端论坛<br>
							        <span class="right-intro"></span>
							    </span>
							    <a class="shuline" style="height: 80px"></a>
							</p>
							<p class="time-line-content">
							    <span class="fontWhite font14">17:45-20:00</span>
							    <span class="point"></span>
							    <span class="fontWhite font14">
							        晚宴<br>
							        <span class="right-intro"></span>
							    </span>
							    <!-- <a class="shuline" style="height: 90px"></a> -->
							</p>
                        </div>                        
                    </div>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;嘉&nbsp;&nbsp;&nbsp;宾&nbsp;&nbsp;&nbsp;介&nbsp;&nbsp;&nbsp;绍</span></p>
					<div class="meeting-jbjs center mt40">
                        <el-row :gutter="20" class="mw-modular-box">
                            <el-col :span="8">
                                <div class="textCenter">
                                    <img src="../../assets/images/ej/activity_boxing/01宋雷.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">河北唐宋大数据产业股份有限公司<br/>董事长 宋雷</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter">
                                    <img src="../../assets/images/ej/activity_boxing/02郭垣辰.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">山东大宗商品交易中心<br/>市场业务部总监 郭垣辰</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter">
                                    <img src="../../assets/images/ej/activity_boxing/03魏智海.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">德天（天津）国际贸易发展有限公司<br/>总经理助理 魏智海</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/ej/activity_boxing/04王林南.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">赤峰中唐特钢有限公司<br/>销售部副部长 王林南</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/ej/activity_boxing/05娄童贤.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 15px; line-height: 30px; padding: 15px 10px; height: 40px;">山东能源集团营销贸易有限公司<br/>期货总监 大宗商品研究院负责人 娄童贤</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/ej/activity_boxing/06郑威.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">东亚期货<br/>黑色产业研究负责人 郑威</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/ej/activity_boxing/07李汉尊.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">天津源泰德润钢管制造集团有限公司<br/>营销部经理 李汉尊</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/ej/activity_boxing/08王兰彩.jpg" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">河北唐宋大数据产业股份有限公司<br/>分析师 王兰彩</p>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;高&nbsp;&nbsp;&nbsp;端&nbsp;&nbsp;&nbsp;访&nbsp;&nbsp;&nbsp;谈</span></p>
                    <div id="marqueeBox" name="marqueeBox" class="index-quote-list-box">
                        <div class="inlineBlock img-box" @click="showImgDetail(0)">
                            <img src="../../assets/images/ej/activity_boxing/01.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(1)">
                            <img src="../../assets/images/ej/activity_boxing/02.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(2)">
                            <img src="../../assets/images/ej/activity_boxing/03.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(3)">
                            <img src="../../assets/images/ej/activity_boxing/04.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(4)">
                            <img src="../../assets/images/ej/activity_boxing/05.jpg" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(5)">
                            <img src="../../assets/images/ej/activity_boxing/06.jpg" alt="" height="150px">
                        </div>
                    </div>
                    <el-dialog title="" :visible.sync="dialogVisible" width="40%">
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <div>
                                    <img :src="dialogImg" alt="" class="w100">
                                </div>
                            </el-col>
                        </el-row>
                    </el-dialog>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;赞&nbsp;&nbsp;&nbsp;助</span></p>
                    <div class="meeting-zanzhu center textCenter">
                        <p class="zanzhu-title mt30">主办单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8" :offset="8">
                                <div class="zanzhu-center">河北唐宋大数据产业股份有限公司</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">独家冠名</p>
                        <el-row :gutter="20">
                            <el-col :span="8" :offset="8">
                                <div class="zanzhu-center">德天 (天津) 国际贸易发展有限公司</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">联合主办</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">天津源泰德润钢管制造集团有限公司 </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">赤峰中唐特钢有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">上海东亚期货有限公司</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">协办单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">河北东海特钢集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">山东大宗商品交易中心</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">山东中联易达供应链有限公司</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">支持单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">唐山瑞丰钢铁 (集团) 有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">河北普阳钢铁有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">五矿钢铁青岛有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">山东能源集团营销贸易有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">山东万事达控股有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">山东远大集团公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">山东金恒业钢铁有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">山东新乐华钢铁有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">唐山靷势黑金有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">山东烨辉涂渡钢板有限公司</div>
                            </el-col>
                        </el-row>
						
						<p class="zanzhu-subtitle mt30">酒水赞助</p>
						<el-row :gutter="20">
						    <el-col :span="8" :offset="8">
						        <div class="zanzhu-center">山东肆方酒业有限公司(贵州省省酒滨州总代理)</div>
						    </el-col>
						</el-row>
                    </div>
                </div>
            </div>
            <div class="meeting-yt">
                <p class="meeting-yt-title center textCenter"><span>&nbsp;大&nbsp;&nbsp;&nbsp;会&nbsp;&nbsp;&nbsp;地&nbsp;&nbsp;&nbsp;点</span></p>
                <div class="meeting-address">
                    <div style="margin-top: 40px" class="mw-modular-box fontWhite textCenter">
                        <h3 style="line-height: 40px; font-size: 24px">山东省滨州市博兴县中悦国际大酒店</h3>
                        <p style="line-height: 40px; font-size:24px">山东省滨州市博兴县西外环路1号</p>
                    </div>
                    <div class="address-bg textCenter">
                        <a href="https://map.baidu.com/search/%E6%BB%A8%E5%B7%9E%E5%B8%82%E5%8D%9A%E5%85%B4%E5%8E%BF%E4%B8%AD%E6%82%A6%E5%9B%BD%E9%99%85%E5%A4%A7%E9%85%92%E5%BA%97/@13161917.076402465,4418276.70970405,19z?querytype=s&da_src=shareurl&wd=%E6%BB%A8%E5%B7%9E%E5%B8%82%E5%8D%9A%E5%85%B4%E5%8E%BF%E4%B8%AD%E6%82%A6%E5%9B%BD%E9%99%85%E5%A4%A7%E9%85%92%E5%BA%97&c=138&src=0&pn=0&sug=0&l=19&b=(12588554.93,2606004.12;12589408.43,2606462.12)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2" target="_blank">
                            <img src="../../assets/images/ej/activity_boxing/map.jpg" alt="" srcset="" class="">
                        </a>
                    </div>
                </div>
            </div>
            <div class="meeting-yt">
                <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;务&nbsp;&nbsp;&nbsp;联&nbsp;&nbsp;&nbsp;系</span></p>
                <div class="meeting-concat center font16 fontWhite mt40">
                    <p class="textCenter" style="line-height: 40px;">
                        河北唐宋大数据产业股份有限公司&nbsp;&nbsp;&nbsp;&nbsp;回执传真至：0315-5921091/92<br>
                        会务联系人：王慧 18231525225&nbsp;&nbsp;&nbsp;&nbsp;路亚旭 15830588702
                    </p>
                    <el-row style="margin-top: 10px; padding-bottom: 30px;">
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/act_code1.png" alt="" width="100px">
                                <small style="display: block;line-height: 40px;">在线监测预警公众号</small>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/02唐宋钢铁APP.jpg" alt="" width="100px">
                                <p style="line-height: 35px;">唐宋APP</p>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/03在线监测预警公众号.jpg" alt="" width="100px">
                                <p style="line-height: 35px;">在线监测预警</p>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </article>

        <ConcatsControl></ConcatsControl>
    </div>
</template>
<script>
import $ from 'jquery'
import QRCode from 'qrcode'
import '../../assets/js/jquery.liMarquee.js'
import { baseUrl, getQueryString, adIDs } from '../../assets/js/common'
import ConcatsControl from '../../templates/concatsControl'
export default {
    name: 'activitiesDetail2021gz',
    components: { ConcatsControl },
    data() {
        return {
            liMarquee: null,
            dialogVisible: false,
            dialogImg: '',
            imgs: [
                require('../../assets/images/ej/activity_boxing/01.jpg'),
                require('../../assets/images/ej/activity_boxing/02.jpg'),
                require('../../assets/images/ej/activity_boxing/03.jpg'),
                require('../../assets/images/ej/activity_boxing/04.jpg'),
                require('../../assets/images/ej/activity_boxing/05.jpg'),
                require('../../assets/images/ej/activity_boxing/06.jpg'),
            ],
            imgsDetailNames: 
            [
                // ['河北普阳钢铁有限公司', '河北津西钢铁集团股份有限公司', '秦皇岛宏兴钢铁有限公司', '唐山市德龙钢铁有限公司', '山西晋南钢铁集团有限公司', '河北天柱钢铁集团有限公司', '天津荣程联合钢铁集团有限公司', '唐山东华钢铁企业集团有限公司', '河北安丰钢铁有限公司', '江苏徐钢钢铁集团有限公司'], // 钢铁生产企业
                // ['厦门海翼国际贸易有限公司', '浙江物产金属集团有限公司', '中基宁波集团股份有限公司', '成大物产（厦门）有限公司', '浙商中拓集团股份有限公司', '山东天保工贸有限公司', '天津启润投资有限公司', '苏美达国际技术贸易有限公司', '杭州热联集团股份有限公司', '江苏象石实业股份有限公司'], // 综合贸易企业
                // ['新绛天地和金属制品有限公司', '天津市群胜达钢管有限公司', '天津友发钢管集团股份有限公司', '山东舜世高科实业有限公司', 'ZDP正大制管有限公司', '霸州市众丰金属制品有限公司', '天津市可楠钢管有限公司', '天津市宝来工贸有限公司', '河北盛泰制管有限公司', '天津市利达钢管集团有限公司'], // 钢管制造企业
                // ['唐山海翼宏润物流有限公司', '浙江物产物流投资有限公司唐山分公司', '厦门国贸启铭物流有限公司', '唐山市丰领物流有限公司', '四川乐送物流股份有限公司', '河北兴泰物流有限公司', '唐山象屿正丰国际物流有限公司', '唐山市双赢物流有限公司', '邯郸新铁物流有限公司', '唐山东方海运有限公司'], // 钢铁物流企业
                // ['唐山友利焦化有限公司', '武安市广普焦化有限公司', '介休市昌盛煤气化有限公司', '山西安泰集团股份有限公司', '唐山东方炼焦制气有限公司', '乌海市广纳煤焦化有限公司', '河北华丰能源科技发展有限公司', '山西潞宝集团焦化有限公司', '唐山达丰焦化有限公司', '山西亚鑫煤焦化有限公司'], // 焦化生产企业
                // ['秦皇岛顺先钢铁有限公司', '天津市震翔板带加工有限公司', '唐山市丰润区鸿翔金属制品有限公司', '唐山首唐宝生功能材料有限公司', '唐山如隆实业有限公司', '唐山市丰润区鑫通源扁钢厂', '唐山宏润实业有限公司', '唐山市德物精密制品有限公司 ', '江苏卓群金属科技有限公司', '唐山市丰润区永强轧钢厂'], //钢加工企业
                // ['河北津西新材料科技有限公司', '泊头市宝发彩钢钢构工程有限公司', '庆云华兴钢架工程有限公司', '宏德瑞琳金属结构制造有限公司', '邯郸市银蝉贸易有限公司', '潍坊长安铁塔股份有限公司', '天津市鑫跃达工贸有限公司', '邯郸市泽业贸易有限公司', '邯郸市恒特板材加工有限公司', '邯郸市华威钢结构工程有限公司'], // 钢结构生产企业
                // ['本溪市远通物资回收有限公司', '朝阳议通金属再生资源有限公司', '天津城矿再生资源回收有限公司', '武安市永鑫再生资源利用有限公司', '天津德邦（邢台县）再生资源利用有限公司', '扬州鸿蓝钢铁加工有限公司', '天津振泓再生资源有限公司', '天津宏业兴再生物资回收有限公司', '浙商中拓集团江西再生资源有限公司', '河南冀物再生资源有限公司'], // 废钢回收加工企业
                // ['上海东亚期货有限公司', '中辉期货有限公司', '宏源期货有限公司', '徽商期货有限责任公司', '永安期货股份有限公司', '国投安信期货有限公司', '国泰君安期货有限公司', '银河期货有限公司', '国海良时期货有限公司', '中国国际期货股份有限公司'], // 期货企业
                // ['辽宁海力特种石油装备有限公司', '上海鸿网供应链股份有限公司', '中国检验认证集团河北有限公司', '钢谷电子商务股份有限公司', '德邻智联（鞍山）有限公司', '日照大宗商品交易中心', '中瑞和（天津）供应链管理服务有限公司', '唐山曹妃甸实业港务有限公司', '北京恒润九州实业有限公司', '秦皇岛佰工钢铁有限公司'], // 服务企业
                // ['厦门国贸集团股份有限公司', '唐山凯荣国际贸易有限公司', '中航国际钢铁贸易有限公司', '天津锦亿供应链管理有限公司', '嘉吉投资（中国）有限公司', '浙江物产金属集团有限公司', '河钢集团北京国际贸易有限公司', '山东建邦联合进出口有限公司', '山东环富国际贸易有限公司', '日照兴业集团有限公司'], //铁矿石供应商
                // ['唐山和朋贸易有限公司', '山东中垠国际贸易有限公司', '唐山永联国际贸易有限责任公司', '山东冀中瀚能供应链管理有限公司', '唐山市五山商贸有限公司', '厦门象屿股份有限公司', '易大宗（北京）供应链管理有限公司', '山东潍焦集团薛城能源有限公司', '山西省焦炭集团经销贸易有限公司', '重庆喜丰春瑞供应链管理有限公司'], // 煤焦供应商
                // ['天津瑞鑫昌科技有限公司', '河北港济实业有限公司', '河北港禾实业发展有限公司', '浙江开迪贸易有限公司', '江阴市铁实供应链有限公司', '上海俱丰供应链有限公司', '迁安市瑞虎商贸有限公司', '唐山市晨丰商贸有限公司', '天津市仁通钢铁有限公司', '唐山海瀚国际贸易有限公司'], // 钢坯供应商
                // ['唐山市丰润区乔羽贸易有限公司', '山西浩正鸿瑞贸易有限公司', '河北华贸电力新材料有限公司', '宁波荣城金属材料有限公司', '鞍山市鑫华通贸易有限公司', '唐山市丰润区超翼商贸有限公司', '邯郸市裕驰贸易有限公司', '泰安市延峰物资有限公司', '唐山市丰润区建源商贸有限公司', '唐山朗威进出口贸易有限公司'], // 型钢供应商
                // ['汇金工贸（天津）有限公司', '邯郸市钢盈贸易有限公司', '山东新乐华钢铁有限公司', '青岛鸿利宇供应链有限公司', '邯郸市泰虎贸易有限公司', '河北邯城贸易有限公司', '河北泰岳峰钢铁贸易有限公司', '唐山市炳旭实业有限公司', '中船重工物资贸易集团有限公司', '邯郸市晟德贸易有限公司'], // 板材供应商
                // ['辽宁紫中供应链有限责任公司', '河南豫之钢贸易有限公司', '万豪钢铁集团有限公司', '任丘市亚丰建筑器材有限公司', '中铁铁龙（营口）国际物流贸易有限公司', '唐山宏腾贸易有限公司', '陕钢集团韩城钢铁有限责任公司', '福建点增贸易有限公司', '山西兴合邦物资有限公司', '山东蓝天新材料科技有限公司'], // 建材供应商
                // ['天津市仁翼博爱国际商贸有限公司', '无锡市启升金属材料有限公司', '天津市宏英丰达金属材料销售有限公司', '瑞信国际贸易有限公司', '天津市智恒达商贸有限公司', '迁安市瑞虎商贸有限公司', '天津市丰隆商贸有限公司', '天津中拓电子商务有限公司', '上海塔杰实业有限公司', '天津勤兴敬业科技有限公司'], // 带钢供应商
                // ['天津市民阁商贸有限公司', '广州市华利丰钢材贸易有限公司', '南京友发物资有限公司', '奎鑫钢首集团', '唐山市青坤贸易有限公司', '霸州市广义制管有限公司', '天津海翼钢铁销售有限公司', '天津德汇钢铁贸易有限公司', '天津宏盛强钢铁有限公司', '天津市德健钢管有限公司'], // 钢管供应商
            ],
            sjDetailData: []
        }
    },
    mounted () {
        this.id = getQueryString('id');
        // this.getAdByAdp();
        this.marqueeInit();
    },
    methods: {
        // 获取广告信息
        // getAdByAdp () {
        //     const self = this;
        //     self.adIDsIndex.forEach((item, index) => {
        //         self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
        //             if (res.code == 0) {
        //                 self.adIDsIndex[index]['list'] = res.data;
        //             }
        //         })
        //     })
        // },
        marqueeInit () {
            const self = this;
            $('.index-quote-list-box').liMarquee('destroy');
            setTimeout(() => {
                $('.index-quote-list-box').liMarquee({
                    scrollamount: 120,
                    hoverstop: true,
                    circular: false
                });
            }, 500)
            
            
        },
        showImgDetail (index) {
            this.dialogImg = this.imgs[index];
            this.sjDetailData = this.imgsDetailNames[index];
            this.dialogVisible = true;
        }
    }
    
}
</script>

<style scoped>
    @import url('../../assets/css/liMarquee.css');
    .content-bg {
        background: url('../../assets/images/ej/activeTopbg.jpg') no-repeat;
        background-size: 100% auto;
        position: relative;
    }
    .logo-position {
        position: absolute;
        top: 60px;
        left: 60px;
        color: #fff;
    }
    .logo-position > p { font-size: 20px; }
    .logo-position > div > span { display: inline-block; margin-bottom: 20px; width: 8px; border-top: 2px solid #fff;}
    .mt10 { margin-top: 10px; }
    .mt40 { margin-top: 40px; }
    .mt30 { margin-top: 30px; }
    .title-text { font-size: 28px; letter-spacing: 10px; }
    .title-text-en { font-size: 20px; letter-spacing: 4px; font-weight: 100;}
    .time-text { 
        background: url('../../assets/images/ej/activeTimebg.png') no-repeat; 
        background-size: 100% 100%;
        line-height: 40px;
        width: 600px;
        font-size: 14px;
        font-weight: 600;
    }
    .meeting-jj {
        background: rgba(0, 0, 0, 0.4);
        font-size: 16px;
        color: #fff;
        line-height: 35px;
        width: 700px;
        padding: 20px 30px;
        letter-spacing: 1px;
        margin-top: 60px;
    }
    .meeting-jj-title {
        font-size: 20px;
        margin-bottom: 10px;
    }
    .meeting-yt {
        margin-top: 60px;
    }
    .meeting-yt-title {
        background: url('../../assets/images/ej/activeTitlebg.png') no-repeat;
        background-size: 100% 100%;
        width: 600px;
        height: 60px;
    }
    .meeting-yt-title span {
        background-image: -webkit-linear-gradient(bottom, #ffc67d, #f6c195, #fbdcbf); 
        -webkit-background-clip: text; 
        -webkit-text-fill-color: transparent;
        line-height: 60px;
        font-size: 30px;
        font-weight: 600;
    }
    .meeting-yc-content {
        width: 1000px;
        box-sizing: border-box;
    }
    .meeting-yc-content > h2 {
        border-left: 10px solid #024e9a;
        padding-left: 20px;
        color: #fff;
    }
    .line { border-top: 1px solid #024e9a; margin-top: 10px; }
    .time-line-content { position: relative; margin-top: 40px; }
    .time-line-content span { display: inline-block; font-size: 16px; vertical-align: top; }
    .point {
        background: url('../../assets/images/ej/activeTimePoint.png') no-repeat;
        background-size: 100% 100%;
        width: 15px;
        height: 15px;
        margin: 0 30px;
        vertical-align: bottom;
        margin-top: 4px;
    }
    .right-text {
        color: #FBFBFB;
        margin-left: 30px;
        font-weight: 600;
        line-height: 30px;
        margin-top: -5px;
		font-weight: 400;
    }
    .time-line-content .right-intro {
        color: #FBFBFB;
        font-size: 14px;
        line-height: 40px;
		font-weight: 700;
    }
    .shuline {
        position: absolute;
        height: 80px;
        border-left: 1px solid #fff;
        top: 19px;
        left: 126px;
    }
    .meeting-jbjs {
        border: 8px solid #0350a0;
        box-sizing: border-box;
        width: 1000px;
        padding: 20px;
        color: #d6be98;
    }
    .detail-user-img { width: 100%; height: 200px;  }
    .index-quote-list-box { width: 1000px; height: 360px; overflow: hidden; box-sizing: border-box; border: 8px solid #0350a0; margin: 30px auto; }
    .index-quote-list-box .img-box { padding: 30px 10px 10px 10px;  }
    .index-quote-list-box p { line-height: 40px; font-size: 16px; color: #d6be98; }
    .meeting-zanzhu { width: 1000px; }
    .zanzhu-title,
    .zanzhu-subtitle { color: #fd7744; font-size: 18px; }
    .zanzhu-subtitle { color: #ffd79f; }
    .zanzhu-left,
    .zanzhu-center,
    .zanzhu-right { line-height: 35px; width: 100%; background: url('../../assets/images/ej/one.png') no-repeat; background-size: 100% 100%; margin: 10px 0; font-size: 14px; color: #fff;}
    .zanzhu-center { background: url('../../assets/images/ej/two.png') no-repeat; background-size: 100% 100%; }
    .zanzhu-right { background: url('../../assets/images/ej/three.png') no-repeat; background-size: 100% 100%; }
    .meeting-address { padding-bottom: 30px; }
    .address-bg {
        background: url('../../assets/images/ej/addressbg.png') no-repeat;
        background-size: 100% 100%;
        padding-top: 50px;
    }
    .address-bg img { width: 1000px; }
    .meeting-concat { width: 1000px; }
</style> 